import { useSyncExternalStore } from 'react';

let query: MediaQueryList | null = null;

function getQuery() {
  if (query === null && typeof window !== 'undefined') {
    query = window.matchMedia('(display-mode: standalone)');
  }
  return query;
}

function subscribe(callback: () => void) {
  const mql = getQuery();
  mql?.addEventListener('change', callback);
  return () => mql?.removeEventListener('change', callback);
}

function getSnapshot() {
  return getQuery()?.matches ?? false;
}

function getServerSnapshot() {
  return false;
}

export function useStandaloneMode() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
